import useForbiddenSnackbar from "@hooks/useForbiddenSnackbar";
import useLocales from "@hooks/useLocales";
import { useSnackbar } from "notistack";
import {
  deletePurchaseRequisition,
  postPurchaseRequisition,
} from "../services/purchaseRequisitionService";

export const usePurchaseRequisitionApi = (fetchList: () => Promise<void>) => {
  const { translate } = useLocales();
  const { enqueueSnackbar } = useSnackbar();
  const { notifyForbidden } = useForbiddenSnackbar();

  const handleDelete = async (documentId: string) => {
    const { error, forbidden } = await deletePurchaseRequisition(documentId);
    if (forbidden) {
      notifyForbidden("Procurement", "delete");
      return;
    }

    if (error) {
      enqueueSnackbar(translate(error), { variant: "error" });
      return;
    }

    enqueueSnackbar(translate("purchase_requisition_deleted_successfully"), {
      variant: "success",
    });
    fetchList();
  };

  const handlePost = async (documentId: string) => {
    try {
      const res: any = await postPurchaseRequisition(documentId);
      if (!res.error) {
        enqueueSnackbar(translate("posted_successfully"), {
          variant: "success",
        });
        fetchList();
      } else {
        const errorDetail = res.data?.Detail || res.message || res.error;
        const messageKey = errorDetail?.includes("already finalized")
          ? "purchase_requisition_already_finalized"
          : "something_went_wrong";

        enqueueSnackbar(translate(messageKey), { variant: "error" });
      }
    } catch (error: any) {
      enqueueSnackbar(translate("something_went_wrong"), { variant: "error" });
    }
  };

  return { handleDelete, handlePost };
};
